const AccountManageLayout = () => import('@/layout/accountManageLayout.vue');

export const accountManageWhitelist = [
    '/accountManage',
    '/accountManage/overview',
    '/accountManage/modelExperience',
    '/accountManage/apiKeys',
    '/accountManage/modelSquare',
    '/accountManage/modelSquareDetail',
    '/accountManage/usageStats',
    '/accountManage/accountOverview',
    '/accountManage/accountDetail',
    '/accountManage/rechargeRecord',
    '/accountManage/consumptionDetail',
    '/accountManage/devDocs',
    '/accountManage/quotaManage',
    '/accountManage/modelRate',
    '/accountManage/messageNotice',
];

export default {
    path: '/accountManage',
    name: 'accountManage',
    redirect: '/accountManage/overview',
    component: AccountManageLayout,
    meta: {
        title: 'Account Management',
        i18n: 'route.accountManage',
        hideHeader: true,
    },
    children: [
        {
            path: 'overview',
            name: 'accountOverview',
            component: () => import('@/views/accountManage/overview/index.vue'),
            meta: {
                title: 'Overview',
                i18n: 'route.overview',
            },
        },
        {
            path: 'modelExperience',
            name: 'accountModelExperience',
            component: () => import('@/views/accountManage/modelExperience/index.vue'),
            meta: {
                title: 'Model Experience',
                i18n: 'route.modelExperience',
            },
        },
        {
            path: 'apiKeys',
            name: 'accountApiKeys',
            component: () => import('@/views/accountManage/apiKeys/index.vue'),
            meta: {
                title: 'API Keys',
                i18n: 'route.apiKeys',
            },
        },
        {
            path: 'modelSquare',
            name: 'accountModelSquare',
            component: () => import('@/views/accountManage/modelSquare/index.vue'),
            meta: {
                title: 'Model Square',
                i18n: 'route.modelSquare',
            },
        },
        {
            path: 'modelSquareDetail',
            name: 'accountModelSquareDetail',
            component: () => import('@/views/accountManage/modelSquare/detail.vue'),
            meta: {
                title: 'Model Detail',
                i18n: 'route.modelDetail',
            },
        },
        {
            path: 'usageStats',
            name: 'accountUsageStats',
            component: () => import('@/views/accountManage/usageStats/index.vue'),
            meta: {
                title: 'Usage Statistics',
                i18n: 'route.usageStats',
            },
        },
        {
            path: 'accountOverview',
            name: 'accountFeeOverview',
            component: () => import('@/views/accountManage/accountOverview/index.vue'),
            meta: {
                title: 'Account Overview',
                i18n: 'route.accountOverview',
            },
        },
        {
            path: 'accountDetail',
            name: 'accountFeeDetail',
            component: () => import('@/views/accountManage/accountDetail/index.vue'),
            meta: {
                title: 'Account Details',
                i18n: 'route.accountDetail',
            },
        },
        {
            path: 'rechargeRecord',
            name: 'accountRechargeRecord',
            component: () => import('@/views/accountManage/rechargeRecord/index.vue'),
            meta: {
                title: 'Recharge Records',
                i18n: 'route.rechargeRecord',
            },
        },
        {
            path: 'consumptionDetail',
            name: 'accountConsumptionDetail',
            component: () => import('@/views/accountManage/consumptionDetail/index.vue'),
            meta: {
                title: 'Consumption Details',
                i18n: 'route.consumptionDetail',
            },
        },
        {
            path: 'devDocs',
            name: 'accountDevDocs',
            component: () => import('@/views/accountManage/devDocs/index.vue'),
            meta: {
                title: 'Dev Docs',
                i18n: 'route.devDocs',
            },
        },
        {
            path: 'quotaManage',
            name: 'accountQuotaManage',
            component: () => import('@/views/accountManage/quotaManage/index.vue'),
            meta: {
                title: 'Quota Management',
                i18n: 'route.quotaManage',
            },
        },
        {
            path: 'modelRate',
            name: 'accountModelRate',
            component: () => import('@/views/accountManage/modelRate/index.vue'),
            meta: {
                title: 'Model Rate',
                i18n: 'route.modelRate',
            },
        },
        {
            path: 'messageNotice',
            name: 'accountMessageNotice',
            component: () => import('@/views/accountManage/messageNotice/index.vue'),
            meta: {
                title: 'Notifications',
                i18n: 'route.messageNotice',
            },
        },
    ],
};
